import { create } from 'zustand';
import { redux } from 'zustand/middleware';
import { IComponentUnion, ITrackingImageData } from '../components/r3f-components/component-data-structure';
// import { devtools } from 'zustand/middleware';
import { IWebEmbedSettings } from '../components/r3f-components/component-data-structure/types/webEmbed';
import { IDeviceType } from '../components/r3f-components/component-data-structure/types/device';
import { IGrabAndGoOptions } from '@/components/r3f-components/component-data-structure/types/grabAndGo';

export enum IMode {
	nonar = 'nonar',
	ar = 'ar'
}

export type ITrackingImageFileData = {file: ArrayBuffer, imageUrl: string, radius?: number} & ITrackingImageData

export interface ITrackingImageDict {
	[filestoreId: string]: ITrackingImageFileData;
}

export enum IDataActions {
	ADD_CONTENT = 'ADD_CONTENT',
	ADD_ROOT_ID = 'ADD_ROOT_ID',
	SET_MODE = 'SET_MODE',
	SET_WEBXR = 'SET_WEBXR',
	SET_GRAB_N_GO_OPTIONS = 'SET_GRAB_N_GO_OPTIONS'
}

interface IAddContent {
	type: IDataActions.ADD_CONTENT;
	componentsById?: { [id: string]: IComponentUnion };
	trackingImageDict?: ITrackingImageDict;
	webXR?: IDeviceType | null;
	shadowsEnabled?: boolean;
	webEmbed?: IWebEmbedSettings;
	grabNGoOptions?: IGrabAndGoOptions;
}

interface IAddRootId {
	type: IDataActions.ADD_ROOT_ID;
	rootId: string;
}

interface ISetMode {
	type: IDataActions.SET_MODE;
	mode: IMode;
}

interface ISetWebXR {
	type: IDataActions.SET_WEBXR;
	device: IDeviceType;
}

type IActionObjUnion = IAddContent | IAddRootId | ISetMode | ISetWebXR;

type IDataState = {
	componentsById: { [id: string]: IComponentUnion } | null;
	rootId: string | null;
	shadowsEnabled?: boolean;
	trackingImageDict?: ITrackingImageDict | null;
	mode?: IMode;
	webXR?: IDeviceType | null;
	webEmbed?: IWebEmbedSettings;
	dispatch?: (args: IActionObjUnion) => IActionObjUnion;
};

const initialState: IDataState = {
	rootId: null,
	trackingImageDict: {},
	componentsById: null,
};

function reducer(state: IDataState, action: IActionObjUnion): IDataState {
	switch (action.type) {
		case IDataActions.ADD_CONTENT: {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			const { type, ...rest } = action;
			return { ...state, ...rest };
		}
		case IDataActions.ADD_ROOT_ID: {
			return { ...state, rootId: action.rootId };
		}
		case IDataActions.SET_MODE: {
			return { ...state, mode: action.mode}
		}
		case IDataActions.SET_WEBXR: {
			return { ...state, webXR: action.device}
		}
		default: 
			return state
	}
}

export const useDataStore = create(redux(reducer, initialState));
//export const useDataStore = create(devtools(redux(reducer, initialState)));

